<br/>
<dx-validation-group id="REFE">
  <!-- creates a accordion per referencetype, so each accoredion is its own own input control -->
  @for (item of referenceTypes; track item) {
    <np-inputControl
        [(model)]="model"
        [showLinkButtons]="false"
        [suppressLabel]="true"
        [suppressPlaceLabel]="true"
        [(selectedElements)]="selectedElements"
        (elementSelected)="templateSelect($event, item)"
        (onValueChanged)="update($event)"
        [field]="'PRODUCT_REFERENCES_' + item"
        [showDragHandle]="showDragHandle"
        [dragFilter]="dragFilter"
        (excelElementDropped)="excelElementDrop($event)"
    >
      <div slot="content" class="contentSlot m-2">
        <dx-accordion class="np-accordion"
                      [dataSource]="[item]"
                      [collapsible]="true"
                      [selectedIndex]="-1"
                      itemTemplate="item"
                      itemTitleTemplate="title">
          <dxo-state-storing [enabled]="true" type="localStorage" storageKey="ReferencesStateNewUIV3"></dxo-state-storing>

          <div *dxTemplate="let data of 'title'">
            <div class="np-accordion-title">
              {{ data | translate }} {{ getReferencesTypeCountText(data) }}
              <dx-button
                  *ngIf="!templateView"
                  [visible]="!readOnly('referenceNew')"
                  stylingMode="text"
                  type="default"
                  (onClick)="showAddReference($event, data)"
                  hint="{{ 'Neue ' | translate }} {{ data | translate }} {{ ' erstellen' | translate }}"
                  icon="add"

              ></dx-button>
            </div>
          </div>
          <div *dxTemplate="let item of 'item'">
            <dx-data-grid
                [dataSource]="getReferencesByType(item)"
                [remoteOperations]="false"
                [rowAlternationEnabled]="true"
                [allowColumnResizing]="true"
                noDataText="{{ 'keine ' + item + '  Referenzen' | translate }}"
                [showBorders]="false"
                [showColumnHeaders]="false"
                [showColumnLines]="false"
                [showRowLines]="false"
                (onRowUpdated)="update($event)"
                (onRowRemoved)="onRowRemoved($event)"
                (onRowRemoving)="onRowRemoving($event)"
                (onRowPrepared)="onReferencePrepared($event)"
                [customizeColumns]="customizeColumns"
            >
              <dxo-editing mode="cell" [allowDeleting]="!readOnly('referenceDelete')" [useIcons]="true"></dxo-editing>
              <dxo-state-storing
                  [enabled]="true"
                  type="localStorage"
                  storageKey="ReferencesStateNewUIV2"
              ></dxo-state-storing>

              <dxi-column
                  dataField="artIdTo"
                  caption="{{ 'Produktnummer' | translate }}"
                  cellTemplate="referenceSpidTemplate"
                  editCellTemplate="referenceSpidTemplate"
                  [width]="200"
              ></dxi-column>
              <div *dxTemplate="let data of 'referenceSpidTemplate'" class="d-flex flex-row">
                <div class="np-field w-100">
                  <np-inputControl
                      [(model)]="model"
                      [showLinkButtons]="showLinkButtons"
                      [showPlaceLabel]="data?.data?.artIdTo?.length > 0"
                      [suppressLabel]="true"
                      (onValueChanged)="update($event)"
                      field="PRODUCT_REFERENCES_SPID"
                      [system]="data.data.order.toString()"
                      [showDragHandle]="false"
                      dragFilter="nodrag"
                  >
                    <div slot="content" class="contentSlot">
                      <dx-text-box [value]="data.data.artIdTo" [readOnly]="true">
                        <dx-validator
                            *ngIf="!templateView"
                            validationGroup="REFE"
                            (onInitialized)="validationService.startAutomaticValidation($event)"
                        >
                          <dxi-validation-rule
                              type="async"
                              [validationCallback]="
                            validationService.validateField('PRODUCT_REFERENCES_SPID', data.data.order.toString())
                          "
                          ></dxi-validation-rule>
                        </dx-validator>
                      </dx-text-box>
                    </div>
                  </np-inputControl>
                </div>
              </div>

              <dxi-column
                  dataField="normUri"
                  caption=""
                  [allowEditing]="false"
                  editCellTemplate="imageCellTemplate"
                  cellTemplate="imageCellTemplate"
                  [width]="70"
              ></dxi-column>
              <div *dxTemplate="let data of 'imageCellTemplate'" class="w-100">
                <div>
                  <img *ngIf="!data.value" src="images/ikon_article_tree_invert.png" class="catlistImage"/>
                  <img *ngIf="data.value" src="{{ data.value }}" class="catlistImage" id="link{{ data.rowIndex }}"/>
                </div>
              </div>

              <dxi-column
                  dataField="descriptionShort"
                  [allowEditing]="false"
                  caption="{{ 'Produkt' | translate }}"
                  cellTemplate="referenceDescriptionShortTemplate"
                  [allowSearch]="false"
                  [allowSorting]="false"
              ></dxi-column>
              <dxi-column
                  *ngIf="quantityAllowedForType(item)"
                  dataField="quantity"
                  caption="{{ 'Menge' | translate }}"
                  cellTemplate="referenceQuantityTemplate"
                  editCellTemplate="referenceQuantityTemplate"
                  [allowSearch]="false"
                  [allowSorting]="false"
                  [width]="200"
              ></dxi-column>
              <div *dxTemplate="let data of 'referenceQuantityTemplate'" class="d-flex flex-row align-items-center">
                <span class="me-2" style="white-space: nowrap;">{{ 'Menge' | translate }}</span>
                <div class="np-field w-100">
                  <dx-number-box
                      [(value)]="data.data.quantity"
                      [min]="0"
                      [showSpinButtons]="true"
                      [showClearButton]="true"
                      [readOnly]="readOnly('referenceNew')"
                      (onValueChanged)="onQuantityChanged($event)"
                  ></dx-number-box>
                </div>
              </div>
              <div *dxTemplate="let data of 'referenceDescriptionShortTemplate'" class="d-flex flex-row">
                <div class="np-field w-100">
                  <dx-text-box
                      [(value)]="data.data.descriptionShort"
                      [showClearButton]="false"
                      [readOnly]="true"
                  ></dx-text-box>
                </div>
              </div>
            </dx-data-grid>
          </div>
        </dx-accordion>
      </div>
    </np-inputControl>
  }
</dx-validation-group>

<div class="color5Text">
  <div
      *ngIf="
      loginService.currentCustomer.automaticValidation && !validationService.validationResult?.productReferenceValid
    "
  >
    <table>
      <tr *ngFor="let msg of validationService.validationResult?.referenceMessages">
        <td>
          {{ msg | translate }}
        </td>
      </tr>
    </table>
  </div>
</div>

<dx-popup
    [(visible)]="addVisible"
    title="{{ 'CreateReference' | translate : {type: (typeToAdd | translate)} }}"
    hideOnOutsideClick="true"
    position="center"
    width="800"
    height="400"
>
  <div class="dx-fieldset">
    <div class="dx-field" *ngIf="catalogHasReferenceSources">
      <div class="dx-field-label">{{ 'ReferenzQuelle' | translate }}</div>
      <div class="dx-field-value">
        <dx-select-box
            searchEnabled="true"
            [items]="catalogs"
            [(selectedItem)]="referenceSource"
            searchExpr="catalogName"
            displayExpr="catalogName"
            showDataBeforeSearch="false"
            indicateLoading="true"
            [searchTimeout]="400"
            keyExpr="id"
            (onValueChanged)="onReferenceCatalogChanged($event)"
        ></dx-select-box>
      </div>
    </div>

    <div class="dx-field" *ngIf="!isFreeTextType(typeToAdd)">
      <div class="dx-field-label ">{{ 'Produkt' | translate }}</div>
      <div class="dx-field-value">
        <dx-select-box searchEnabled="true"
                       [dataSource]="productSelectBoxData"
                       valueExpr="supplierPid"
                       [searchTimeout]="400"
                       displayExpr="supplierPid"
                       searchExpr="supplierPid"
                       [showDataBeforeSearch]="false"
                       indicateLoading="true"
                       [(value)]="selectedSupplierPid"
                       (onValueChanged)="selectedNewProduct = $event.component.option('selectedItem')">

          <div *dxTemplate="let item of 'item'">
            <dx-load-indicator [visible]="isLoading"></dx-load-indicator>
            <span [hidden]="isLoading">
            {{ item.supplierPid }} | {{ item.descriptionShort }}
                  </span>
          </div>

        </dx-select-box>
      </div>
    </div>

    <div class="dx-field" *ngIf="isFreeTextType(typeToAdd)">
      <div class="dx-field-label">{{ 'Produktnummer' | translate }}</div>
      <div class="dx-field-value">
        <dx-text-box [(value)]="newArtIdText" [showClearButton]="true"></dx-text-box>
      </div>
    </div>

    <div class="dx-field" *ngIf="quantityAllowedForType(typeToAdd)">
      <div class="dx-field-label">{{ 'Menge' | translate }}</div>
      <div class="dx-field-value">
        <dx-number-box
            [(value)]="newQuantity"
            [min]="0"
            [showSpinButtons]="true"
            [showClearButton]="true"
        ></dx-number-box>
      </div>
    </div>

    <div class="dx-field" style="place-self: center;">
      <dx-button
          *ngIf="canAddReference"
          stylingMode="text"
          type="default"
          text="{{ 'Neue ' | translate }} {{ typeToAdd | translate }} {{ 'Referenz' | translate}} {{ ' erstellen' | translate }}"
          [disabled]="readOnly('referenceNew')"
          (onClick)="addReference()"
      ></dx-button>
    </div>
  </div>
</dx-popup>
